//
// Copyright (c) 2015 by Curalate, Inc.
//

((() => {
    angular.module('curalate').service('ExperiencesService', ['$http', '$q', '$sce',
        function ($http, $q, $sce) {
            const BASE_URL = 'https://experience-service.us-east-1.prod.internal.curalate.com/api/v1/';

            this.CDN_URL = $sce.trustAsUrl('https://cdn.curalate.com/sites/');

            this.getExperienceUrl = function(experienceName, siteName) {
                return '/v1/sites/' + siteName + '/experiences/' + experienceName;
            };

            this.getSiteUrl = function(siteName) {
                return '/v1/sites/' + siteName;
            };

            this.relativeTime = (datetime) => {
                return moment(datetime).from(moment.tz("America/New_York").format())
            };
            
            this.getAllExperiences = () => {
                return processResponse($http.get(BASE_URL + 'experiences'));
            };

            this.getExperience = (experienceName, siteName) => {
                return processResponse($http.get(BASE_URL + 'sites/' + siteName + '/experiences/' + experienceName));
            };

            this.getAllSites = () => {
                return processResponse($http.get(BASE_URL + 'sites'));
            };

            this.getSite = (siteName) => {
                return processResponse($http.get(BASE_URL + 'sites/' + siteName));
            };

            this.deployExperienceVersion = (experienceVersionId, user) => {
                return processResponse($http.post(BASE_URL + 'deploy/experience-version', {
                    id: experienceVersionId,
                    deployer: user
                }));
            };

            this.deploySiteVersion = (siteVersionId, user) => {
                return processResponse($http.post(BASE_URL + 'deploy/site-version', {
                    id: siteVersionId,
                    deployer: user
                }));
            };

            this.getPendingMessage = () => {
                return processResponse($http.get('https://api.icndb.com/jokes/random?limitTo=[nerdy]')).then((response) => {
                    return response.value.joke;
                });
            };

            this.getPreviewContainerUrl = (containerName, siteName, siteVersion) => {
                var versionQueryString = '';
                if (siteVersion) {
                    versionQueryString = '?siteVersion=' + siteVersion;
                }
                return BASE_URL + 'sites/' + siteName + '/containers/' + containerName + '/preview.html' + versionQueryString;
            }

            function processResponse(httpPromise) {
                const deferred = $q.defer();
                httpPromise.then(response => {
                    deferred.resolve(response.data);
                }, response => {
                    const error = response.data;
                    if (typeof error.message !== 'undefined') {
                        deferred.reject(error.message);
                    } else {
                        deferred.reject(error);
                    }
                });
                return deferred.promise;
            }
        },
    ]);
}))();
